import { Link } from '@tanstack/react-router';
import { LegalFooter } from '../components/LegalFooter.js';

// Ersetzt die nackte "Not Found"-Ausgabe des Routers. Wer hier landet, hat eine
// alte oder vertippte URL erwischt — und muss von hier aus die Startseite und
// vor allem die Pflichtseiten (Impressum, Datenschutz, AGB) erreichen können.
export function NotFoundPage() {
  return (
    <div className="flex min-h-dvh w-full flex-col bg-ink px-6 py-12">
      <div className="relative mx-auto flex w-full max-w-sm flex-1 flex-col justify-center text-center">
        <div className="pointer-events-none absolute left-1/2 top-1/4 h-[320px] w-[320px] -translate-x-1/2 rounded-full bg-gold/10 blur-[120px]" />

        <div className="relative z-10">
          <p className="text-[11px] uppercase tracking-[0.4em] text-gold/70">Fehler 404</p>
          <h1 className="mt-4 text-3xl font-semibold tracking-tight text-text">
            Diese Seite gibt es nicht.
          </h1>
          <p className="mt-2 text-sm text-text-dim">
            Der Link ist vermutlich veraltet oder hat sich vertippt.
          </p>

          <div className="mt-8 flex flex-col gap-3">
            {/* Bewusst ein <a>: die Startseite ist die statische Landingpage,
                nicht die SPA — ein Router-Link würde sie nie erreichen. */}
            <a
              href="/"
              className="rounded-2xl bg-gold px-5 py-3 text-sm font-medium text-ink transition hover:bg-gold-light"
            >
              Zur Startseite
            </a>
            <Link
              to="/app"
              className="rounded-2xl border border-line px-5 py-3 text-sm font-medium text-text transition hover:border-gold/50"
            >
              Zur App
            </Link>
          </div>
        </div>
      </div>

      <LegalFooter className="relative z-10 pb-[calc(env(safe-area-inset-bottom)+8px)]" />
    </div>
  );
}
